import { RootState } from 'store';

export const selectFeedbackLoading = (state: RootState) => state.thanksReducer.feedback.status === 'loading';
export const selectFeedbackSubmitted = (state: RootState) => state.thanksReducer.feedback.status === 'success';
